module.exports = __webpack_public_path__ + "static/media/Window-boxIcon.f0da2e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Window-boxIcon.png
// module id = 1811
// module chunks = 0